module.exports = __webpack_public_path__ + "static/media/gps-gris.b645a1b6.svg";